import { NgIf, NgTemplateOutlet, NgClass, AsyncPipe } from '@angular/common'
import { ChangeDetectorRef, Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import {
  CmsBannerComponent,
  CmsService,
  LanguageService,
  PageType,
  SemanticPathService
} from '@spartacus/core'
import { CmsComponentData } from '@spartacus/storefront'
import { Observable, take } from 'rxjs'
import { tap } from 'rxjs/operators'
import { SafeHtmlPipe } from '../pipes/safe-html.pipe'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'
import { EBResponsiveBannerData } from './eb-responsive-banner.interface'

@Component({
  selector: 'eb-responsive-banner',
  templateUrl: './eb-responsive-banner.component.html',
  styleUrls: ['./eb-responsive-banner.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    RouterLink,
    EbResponsiveMediaComponent,
    NgClass,
    AsyncPipe,
    SafeHtmlPipe
  ]
})
export class EBResponsiveBannerComponent {
  public routerLink: string | any[] | undefined
  public externalUrl: string | undefined
  public isExternalLink = false
  public styleClasses: string | undefined
  public isExternalUrlValid: boolean = true

  constructor(
    protected languageService: LanguageService,
    protected componentData: CmsComponentData<EBResponsiveBannerData>,
    protected component: CmsComponentData<CmsBannerComponent>,
    protected urlService: SemanticPathService,
    protected cmsService: CmsService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {}
  validateExternalUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url)
      return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
    } catch (e) {
      console.warn(`Invalid URL provided: ${url}`, e)
      return false
    }
  }
  handleExternalLinkClick(url: string, event: Event): void {
    event.preventDefault()
    if (this.isExternalUrlValid) {
      window.open(url, '_blank')
    } else {
      alert('Invalid external URL. Please try again later.')
    }
  }
  hasUrl(data: EBResponsiveBannerData): boolean {
    return data.urlLink && typeof data.urlLink === 'string' && data.urlLink !== ''
  }

  protected setRouterLink(data: CmsBannerComponent): void {
    this.routerLink = undefined
    this.externalUrl = undefined
    this.isExternalLink = false
    if (data.urlLink) {
      const trimmedUrl = data.urlLink.trim()

      const isExternal =
        /^https?:\/\//.test(trimmedUrl) || (trimmedUrl.includes('.') && !trimmedUrl.startsWith('/'))

      if (isExternal) {
        this.isExternalLink = true
        this.externalUrl = trimmedUrl
        this.isExternalUrlValid = this.validateExternalUrl(trimmedUrl)
      } else {
        this.isExternalLink = false
        this.externalUrl = undefined
        if (trimmedUrl.startsWith('/')) {
          this.routerLink = [trimmedUrl]
        } else {
          this.routerLink = ['/' + trimmedUrl]
        }
      }
    } else if (data.contentPage) {
      this.isExternalLink = false
      this.externalUrl = undefined

      this.cmsService
        .getPage({
          id: data.contentPage,
          type: PageType.CONTENT_PAGE
        })
        .pipe(take(1))
        .subscribe(page => {
          const label = page?.label
          if (label) {
            this.routerLink = [label]
          } else {
            console.warn('CMS content page label is missing:', page)
            this.routerLink = ['/']
          }
          this.changeDetectorRef.markForCheck()
        })
    } else if (data.product) {
      this.isExternalLink = false
      this.externalUrl = undefined
      this.routerLink = this.urlService.transform({
        cxRoute: 'product',
        params: {
          code: data.product,
          fullProductPath: 'product'
        }
      })
    } else if (data.category) {
      this.isExternalLink = false
      this.externalUrl = undefined
      this.routerLink = this.urlService.transform({
        cxRoute: 'category',
        params: { code: data.category }
      })
    }
  }
  protected data$: Observable<EBResponsiveBannerData> = this.component.data$.pipe(
    tap(data => {
      this.setRouterLink(data)
      this.styleClasses = data.styleClasses
    })
  )
}
